import { isMobileDevice } from './constants';

export const formatAsIndianCurrency = (
    value: number,
    showCurrencyLabel: boolean = true,
    navFlag: boolean = false,
) => {
    const options = showCurrencyLabel ? { style: 'currency', currency: 'INR' } : {};
    if (!value) {
        if (navFlag) {
            return 'NA';
        }
        return showCurrencyLabel ? `₹0` : '0';
    }
    if (isMobileDevice() && value > 999) {
        return formatCurrency(value);
    }
    // let x: any = value.toString();
    // let afterPoint = '';
    // if (x.indexOf('.') > 0) afterPoint = x.substring(x.indexOf('.'), x.length);
    // x = Math.floor(x);
    // x = x.toString();
    // var lastThree = x.substring(x.length - 3);
    // var otherNumbers = x.substring(0, x.length - 3);
    // if (otherNumbers != '') lastThree = ',' + lastThree;
    // var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;
    // return showCurrencyLabel ? `₹ ${res}` : `${res}`;
    return new Intl.NumberFormat('en-IN', options).format(value);
};

export function toExactSubstr(str: string) {
    const a = str.split('.');
    if (a.length == 2) {
        return a[0].concat('.', a[1].substr(0, 2));
    }
    return str;
}

export const formatCurrency = (value: number) => {
    const formats = ['K', 'L', 'CR'];
    let amount: any = Number(value);
    formats.some((key, i) => {
        let size = Math.pow(10, i === 0 ? 3 : 3 - 1);
        if (size <= amount) {
            amount = toExactSubstr(`${amount / size}`);
            if (amount >= 100 && i < formats.length - 1) {
                i++;
            } else {
                // amount = (amount * decPlaces) / decPlaces;
                amount += formats[i];
                return true;
            }
        } else {
            return true;
        }
    });
    return amount;
};
